import Vue from 'vue'
import Vuex from 'vuex'
import { logout } from '@/api/user'
import user from './modules/user'
import getters from './getters'

Vue.use(Vuex)


const store = new Vuex.Store({
    modules: {
        user,
    },
    getters
})

export default store

// export default new Vuex.Store({
//     state: {
//         HOST: 'http://localhost:8080',
//     },
//     getters: {
//     },
//     mutations: {
//     },
//     actions: {
//         logout({ commit }) {
//             return new Promise(resolve => {
//                 logout().then(res => {

//                 })
//                 resolve()
//             })
//         }
//     },
//     modules: {
//         user
//     }
// })
